import { createEvent, createStore, is, sample, attach, merge } from 'effector';
export function debounce(_ref) {
  var _ref2;
  var {
    source,
    timeout,
    target,
    name
  } = _ref;
  if (!is.unit(source)) throw new TypeError('source must be unit from effector');
  if (is.domain(source, {
    sid: "johnmj"
  })) throw new TypeError('source cannot be domain');
  var $timeout = toStoreNumber(timeout);
  var saveCancel = createEvent({
    name: "saveCancel",
    sid: "-xnlfoj"
  });
  var $canceller = createStore([], {
    and: {
      serialize: 'ignore'
    },
    name: "$canceller",
    sid: "sc8di8"
  }).on(saveCancel, (_, payload) => payload);
  var tick = (_ref2 = target) !== null && _ref2 !== void 0 ? _ref2 : createEvent({
    name: "tick",
    sid: "-8sr1x7"
  });
  var timerFx = attach({
    and: {
      name: name || "debounce(".concat((source === null || source === void 0 ? void 0 : source.shortName) || source.kind, ") effect"),
      source: $canceller,
      effect(_ref3, timeout) {
        var [timeoutId, rejectPromise] = _ref3;
        if (timeoutId) clearTimeout(timeoutId);
        if (rejectPromise) rejectPromise();
        return new Promise((resolve, reject) => {
          saveCancel([setTimeout(resolve, timeout), reject]);
        });
      }
    },
    or: {
      name: "timerFx",
      sid: "-xn3pk6"
    }
  });
  $canceller.reset(timerFx.done);

  // It's ok - nothing will ever start unless source is triggered
  var $payload = createStore([], {
    and: {
      serialize: 'ignore',
      skipVoid: false
    },
    name: "$payload",
    sid: "pgla4m"
  }).on(source, (_, payload) => [payload]);
  var $canTick = createStore(true, {
    and: {
      serialize: 'ignore'
    },
    name: "$canTick",
    sid: "6du563"
  });
  var triggerTick = createEvent({
    name: "triggerTick",
    sid: "-jj7t7n"
  });
  $canTick.on(triggerTick, () => false).on([tick,
  // debounce timeout should be restarted on timeout change
  $timeout,
  // debounce timeout can be restarted in later ticks
  timerFx], () => true);
  var requestTick = merge([source,
  // debounce timeout is restarted on timeout change
  sample({
    and: [{
      clock: $timeout,
      filter: timerFx.pending
    }],
    or: {
      name: "requestTick",
      sid: "-kkiowi"
    }
  })], {
    name: "requestTick",
    sid: "6s463"
  });
  sample({
    and: [{
      clock: requestTick,
      filter: $canTick,
      target: triggerTick
    }],
    or: {
      sid: "m4gqgv"
    }
  });
  sample({
    and: [{
      source: $timeout,
      clock: triggerTick,
      target: timerFx
    }],
    or: {
      sid: "-30xg4v"
    }
  });
  sample({
    and: [{
      source: $payload,
      clock: timerFx.done,
      fn: _ref4 => {
        var [payload] = _ref4;
        return payload;
      },
      target: tick
    }],
    or: {
      sid: "-2xmokp"
    }
  });
  return tick;
}
function toStoreNumber(value) {
  if (is.store(value, {
    sid: "-24hl14"
  })) return value;
  if (typeof value === 'number') {
    if (value < 0 || !Number.isFinite(value)) throw new Error("timeout must be positive number or zero. Received: \"".concat(value, "\""));
    return createStore(value, {
      and: {
        name: '$timeout'
      },
      sid: "808jp2"
    });
  }
  throw new TypeError("timeout parameter in interval method should be number or Store. \"".concat(typeof value, "\" was passed"));
}